// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as AuthVm$PorterinFeature from "../../../view-model/AuthVm.mjs";
import * as MediaQuery$PorterinUtils from "../../../../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as AuthStore$PorterinFeature from "../../../domain/store/AuthStore.mjs";
import * as NextImage$PorterinFeature from "../../../../../ui/components/NextImage.mjs";
import * as AuthConfig$PorterinFeature from "../../../domain/config/AuthConfig.mjs";
import * as ResendOtpCmp$PorterinFeature from "../resend-otp/ResendOtpCmp.mjs";
import * as ResendOtpTimerModuleScss from "../../styles/ResendOtpTimer.module.scss";

var styles = ResendOtpTimerModuleScss;

function ResendOtpTimerCmp(Props) {
  var set_otp_state = Props.set_otp_state;
  var resend_count = Props.resend_count;
  var seconds = Props.seconds;
  var set_resend_count = Props.set_resend_count;
  var match = React.useState(function () {
        return false;
      });
  var setShowOptions = match[1];
  var is_desktop = MediaQuery$PorterinUtils.useMediaQuery("(min-width: 1024px)");
  var match$1 = resend_count < AuthConfig$PorterinFeature.max_resend_attempts;
  var match$2 = seconds === 0;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: styles["resend-otp-wrapper"]
                }, match$1 ? (
                    match$2 ? React.createElement("span", {
                            className: styles["resend-text"],
                            onClick: (function (param) {
                                if (is_desktop) {
                                  return Curry._1(set_otp_state, (function (param) {
                                                return /* ResendOtp */1;
                                              }));
                                } else {
                                  return Curry._1(setShowOptions, (function (param) {
                                                return true;
                                              }));
                                }
                              })
                          }, React.createElement("p", {
                                className: styles.grey
                              }, AuthStore$PorterinFeature.ResendOtp.resend_otp_enabled_text), React.createElement("p", {
                                className: styles.blue
                              }, AuthStore$PorterinFeature.ResendOtp.resend_otp_enabled_button)) : React.createElement("p", {
                            className: styles["resend-countdown"]
                          }, "" + AuthStore$PorterinFeature.ResendOtp.resend_otp_disabled + " " + String(seconds) + "s")
                  ) : React.createElement("p", {
                        className: styles["resend-countdown"]
                      }, AuthStore$PorterinFeature.ResendOtp.resend_otp_attempts_error), match[0] ? React.createElement("div", {
                        className: styles["resend-options-wrapper"]
                      }, React.createElement("div", {
                            className: styles["close-icon"],
                            onClick: (function (param) {
                                Curry._1(setShowOptions, (function (param) {
                                        return false;
                                      }));
                              })
                          }, React.createElement(NextImage$PorterinFeature.make, {
                                src: AuthVm$PorterinFeature.close_icon.src,
                                height: AuthVm$PorterinFeature.close_icon.height,
                                width: AuthVm$PorterinFeature.close_icon.width,
                                quality: 80.0,
                                alt: AuthVm$PorterinFeature.close_icon.alt
                              })), React.createElement("div", {
                            className: styles["bottom-sheet"]
                          }, React.createElement(ResendOtpCmp$PorterinFeature.make, {
                                set_otp_state: set_otp_state,
                                styles: styles,
                                is_desktop: is_desktop,
                                close_modal: (function (val) {
                                    Curry._1(setShowOptions, (function (param) {
                                            return val;
                                          }));
                                  }),
                                resend_count: resend_count,
                                set_resend_count: set_resend_count
                              }))) : null));
}

var make = ResendOtpTimerCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
